/* eslint-disable @typescript-eslint/no-explicit-any */
import { FieldRenderProps } from 'react-final-form'
import { RefObject } from 'react'
import { TextField } from '@cinch-labs/design-system'

export interface FindACarTextFieldProps extends FieldRenderProps<string> {
  label?: string
  inputRef?: RefObject<HTMLInputElement>
  onChange?: (e: any) => void
  onBlur?: (e: any) => void
  onFocus?: () => void
}

const FindACarTextField = ({
  input,
  onBlur,
  label,
  inputRef,
  onFocus,
  onChange,
  ...rest
}: FindACarTextFieldProps) => (
  <TextField
    {...rest}
    label={label}
    id={rest.id}
    name={input.name}
    type={input.type ? input.type : 'text'}
    value={input.value}
    onChange={(e: any) => {
      input.onChange(e)
      onChange?.(e)
    }}
    onBlur={(e) => {
      input.onBlur(e)
      onBlur?.(e)
    }}
    onFocus={(e) => {
      input.onFocus(e)
      onFocus?.()
    }}
    ref={inputRef}
  />
)

export default FindACarTextField
